import React from 'react';
import styled from 'styled-components';
import { FlexBox, FlexRow, useMatchMedia } from '@make-software/cspr-design';
import AdsBanner from './ads-banner';
import TileSide from '../tile-side/tile-side';

const BannerWrapper = styled(FlexBox)(({ theme }) => ({
  width: '100%',
  padding: '20px 0px',
}));

const DetailsBannerWrapper = styled(BannerWrapper)(({ theme }) => ({
  margin: '24px 0',
}));

export const HomeAdsBanner = ({ screenType }: { screenType?: string }) => {
  const showBannerByScreenType = () => {
    switch (screenType) {
      case 'mobile':
        return (
          <BannerWrapper justify={'center'}>
            <AdsBanner variation={'short'} />
          </BannerWrapper>
        );
      case 'tablet':
        return (
          <BannerWrapper justify={'center'}>
            <AdsBanner variation={'long'} />
          </BannerWrapper>
        );
      default:
        return (
          <FlexRow>
            <AdsBanner variation={'short'} />
          </FlexRow>
        );
    }
  };
  return showBannerByScreenType();
};

export const DetailsAdsBanner = () => {
  const variation = useMatchMedia(['short', 'long', 'long'], []);
  return (
    <DetailsBannerWrapper justify={'center'}>
      <AdsBanner variation={variation} />
    </DetailsBannerWrapper>
  );
};

export const FeedAdsBanner = () => {
  const variation = useMatchMedia(['short', 'long', 'short', 'short'], []);
  return (
    <TileSide>
      <BannerWrapper justify={'center'}>
        <AdsBanner variation={variation} />
      </BannerWrapper>
    </TileSide>
  );
};
